import React, { useEffect, useState } from "react";
import { Badge, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import TableProperties from "./TableProperties";
import Moment from "react-moment";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import { FaArrowsRotate } from "react-icons/fa6";
import { studySiteManagementServices } from "../../../APIServices/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../APIServices/studySubjectManagementServices";
import { studyEventManagementServices } from "../../../APIServices/studyEventManagementServices";
import FilterNotificationDataList from "./FilterNotificationDataList";
import Pagination from "../../Pagination";

const ManageNotificationDataList = ({
  onMouseDown,
  tableRef,
  handleAddNewTab,
}) => {
  const [notificationList, setNotificationList] = useState([]);
  const [notificationListCount, setNotificationListCount] = useState(0);
  const [totalOpenNotification, setTotalOpenNotification] = useState(0);
  const [totalClosedNotification, setTotalClosedNotification] = useState(0);
  const { toggle, setToggle, toggle2, setToggle2 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [storeLoading, setStoreLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [status, setStatus] = useState("");

  const formColumn = [
    { columnLabel: "SiteId", columnName: "SITEID", columnType: "text" },
    { columnLabel: "SubjectId", columnName: "SUBJECTID", columnType: "text" },
    { columnLabel: "EventId", columnName: "EVENTID", columnType: "text" },
    { columnLabel: "Repeat Event", columnName: "REPEATEVENT", columnType: "text" },
    { columnLabel: "Form Name", columnName: "FORMNAME", columnType: "text" },
    { columnLabel: "Field Name", columnName: "FIELDNAME", columnType: "text" },
    {
      columnLabel: "Generated Date | Time",
      columnName: "GENERATEDDT",
      columnType: "text",
    },
    {
      columnLabel: "Notification Day",
      columnName: "NOTIFICATIONDAY",
      columnType: "text",
    },
    {
      columnLabel: "Status",
      columnName: "NOTIFICATIONSTATUS",
      columnType: "text",
    },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(notificationListCount / itemsPerPage);

  const getStudyFormFieldNotificationHistory = async (e) => {
    setLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    userData.page = pageNumber;
    userData.length = itemsPerPage;
    let data =
      await studySiteDataEntryServices.getStudyFormFieldNotificationHistory(
        userData
      );
    setNotificationList(data?.data || []);
    setNotificationListCount(data?.count || 0);
    setTotalOpenNotification(data?.totalOpenNotification || 0);
    setTotalClosedNotification(data?.totalClosedNotification || 0);
    setLoading(false);
  };

  const storeStudyFormFieldNotificationHistory = async (e) => {
    setStoreLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    let data = await studySiteDataEntryServices.storeStudyFormFieldNotificationHistory(
      userData
    );
    if (data?.statusCode === 200) {
      getStudyFormFieldNotificationHistory()
    }
    setStoreLoading(false);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLevelDataNotifications",
      studyId
    );
    setTableColumns(data?.data || {});
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRowData = async () => {
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    setSubjectList(data?.data || [])
  }

  const getStudyEventRowData = async () => {
    let data = await studyEventManagementServices.getStudyEventRowData("active", studyId)
    setEventList(data?.data || [])
  }

  useEffect(() => {
    getTablePropertiesData();
    getStudySiteBasedonAccess()
    getStudyEventRowData()
  }, []);

  useEffect(() => {
    if (siteId) {
      getStudySubjectRowData();
    }
  }, [siteId]);

  useEffect(() => {
    getStudyFormFieldNotificationHistory();
  }, [pageNumber, itemsPerPage]);

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelDataNotifications";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyFormFieldNotificationHistory();
          getTablePropertiesData();
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i title="Open Filter" className="fa-solid fa-filter" onClick={setToggle}></i>
          <div className="vr"></div>
          <div className="sync">
            <FaArrowsRotate
              onClick={(e) => {
                if (!storeLoading) {
                  storeStudyFormFieldNotificationHistory(e);
                }
              }}
              style={{ marginTop: -5 }}
              title={storeLoading ? "Syncing..." : "Sync now"}
              className={storeLoading ? "rotate360 fontSize12" : "CP fontSize12"}
            /> 
          </div>
          {storeLoading && <span className="fontSize12">Syncing...</span>}
        </div>
        <div className="hstack gap-2">
          {notificationListCount > 0 && (
            <div className="gap-1 hstack">
              <Badge className="br3 p-2 text-danger" bg="danger-subtle" style={{ fontSize: 11 }}>Opened Notification: {totalOpenNotification}</Badge>
              <Badge className="br3 p-2 text-success" bg="success-subtle" style={{ fontSize: 11 }}>Closed Notification: {totalClosedNotification}</Badge>
              <button
                onClick={() => {
                  setToggle2();
                  getTablePropertiesData();
                }}
                className={`updateProfile`}
              >
                Table Properties
              </button>
            </div>
          )}
        </div>
      </div>
      <div
        className="overflow-auto"
        style={{ height: "calc(100vh - 179px)" }}
      >
        {loading ? (
          <PageLoader/>
        ) : notificationListCount === 0 ? (
          <NoDataFoundTable MSG={"Notification data list not found!"}/>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  {!tableColumns["SITEID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>SiteId</th>
                  )}
                  {!tableColumns["SUBJECTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>SubjectId</th>
                  )}
                  {!tableColumns["EVENTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>EventId</th>
                  )}
                  {!tableColumns["REPEATEVENT"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 4)} style={{ width: 85 }}>Repeat Event</th>
                  )}
                  {!tableColumns["FORMNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Form Name</th>
                  )}
                  {!tableColumns["FIELDNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Field Name</th>
                  )}
                  {!tableColumns["GENERATEDDT"] && (
                    <th
                      style={{ width: 150 }}
                      onMouseDown={(e) => onMouseDown(e, 7)}
                    >
                      Generated Date | Time
                    </th>
                  )}
                  {!tableColumns["NOTIFICATIONDAY"] && (
                    <th
                      style={{ width: 110 }}
                      onMouseDown={(e) => onMouseDown(e, 8)}
                    >
                      Notification Day
                    </th>
                  )}
                  {!tableColumns["NOTIFICATIONSTATUS"] && (
                    <th
                      style={{ width: 50 }}
                      onMouseDown={(e) => onMouseDown(e, 10)}
                    >
                      Status
                    </th>
                  )}
                  <th
                    onMouseDown={(e) => onMouseDown(e, 12)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Form
                  </th>
                </tr>
              </thead>
              <tbody>
                {notificationList?.map((dataset, index) => (
                  <tr key={index} title="View Details">
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    {!tableColumns["SITEID"] && <td>{dataset?.siteName}</td>}
                    {!tableColumns["SUBJECTID"] && (
                      <td>{dataset?.subjectName}</td>
                    )}
                    {!tableColumns["EVENTID"] && (
                      dataset?.dataEntryType === "specialForm" ?
                        <td>
                          Special Form
                        </td>
                        :
                        <td>
                          {dataset?.eventName}{" "}
                          {dataset?.timePointLabel &&
                            `(${dataset?.timePointLabel})`}
                        </td>
                    )}
                    {!tableColumns["REPEATEVENT"] && (
                      <td>
                        {dataset?.repeatEvent}
                      </td>
                    )}
                    {!tableColumns["FORMNAME"] && (
                      <td>
                        {dataset?.formName} (v{dataset?.formVersion})
                      </td>
                    )}
                    {!tableColumns["FIELDNAME"] && <td>{dataset?.mainFieldName === dataset?.fieldLabel ? dataset?.fieldLabel : (`${dataset?.mainFieldName} | ${dataset?.fieldLabel || ""}`)}</td>}
                    {!tableColumns["GENERATEDDT"] && (
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {dataset?.createdAt}
                        </Moment>
                      </td>
                    )}
                    {!tableColumns["NOTIFICATIONDAY"] && (
                      <td className="text-capitalize">{dataset?.queryDay}</td>
                    )}
                    {!tableColumns["NOTIFICATIONSTATUS"] && (
                      <td
                        className={`text-capitalize fw-bold ${dataset?.status === "open"
                          ? "text-danger"
                          : dataset?.status === "close"
                            ? "text-success"
                            : "text-muted"
                          }`}
                      >
                        {dataset?.status}
                      </td>
                    )}
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() =>
                          handleAddNewTab(
                            dataset?.dataEntryType === "specialForm" ?
                              `Site: ${dataset?.siteName} - Subject: ${dataset?.subjectName} - Event: Special Form` :
                              dataset?.timePointLabel ?
                                `Site: ${dataset?.siteName} - Subject: ${dataset?.subjectName} - Event: ${dataset?.eventName} (${dataset?.timePointLabel})` :
                                `Site: ${dataset?.siteName} - Subject: ${dataset?.subjectName} - Event: ${dataset?.eventName}`,
                            "",
                            "viewEventSchemaFormLists",
                            {
                              siteId: dataset?.siteId,
                              subjectId: dataset?.subjectId,
                              schemaId: dataset?.schemaId,
                              formId: dataset?.formId,
                              formName: dataset?.formName,
                              formVersion: dataset?.formVersion,
                              formType: dataset?.formType,
                              recordId: dataset?.recordId,
                              type: dataset?.dataEntryType === "specialForm" ? "specialForm" : "eventForm",
                              autoForm: "yes",
                              viewType: "dataEntry",
                              eventId: dataset?.eventId,
                              timePointUniqueId: dataset?.timePointUniqueId
                                ? String(dataset?.timePointUniqueId)
                                : "",
                            }
                          )
                        }
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={notificationListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </div>
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <FilterNotificationDataList
        Show={!toggle}
        Hide={setToggle}
        Title={"Filter"}
        siteList={siteList}
        subjectList={subjectList}
        eventList={eventList}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        status={status}
        setStatus={setStatus}
        getStudyFormFieldNotificationHistory={getStudyFormFieldNotificationHistory}
      />
    </>
  );
};

export default ManageNotificationDataList;
